<div class="flex gap-2">
  <app-pan-button [disabled]="params.disableActions()" color="info" icon="edit" (click)="params.editClicked(params.data)" matTooltip="Edit Camera"></app-pan-button>
  <a
    panButton
    [color]="params.data.status === 'GREEN' ? 'success' : 'danger'"
    fill="outline"
    icon="videocam"
    matTooltip="({{ params.data.status === 'GREEN' ? 'Healthy' : 'Unhealthy' }}) Open in Rhombus"
    [href]="params.data.camera_url"
    target="_blank"
  ></a>

  <app-pan-button [disabled]="params.disableActions()" color="info" icon="image" (click)="params.previewCallback(params.data)" matTooltip="Camera Snapshot"></app-pan-button>

  <app-pan-button [disabled]="params.disableActions()" color="danger" icon="delete" (click)="params.deleteCallback(params.data)" matTooltip="Remove Camera"></app-pan-button>
</div>
